import React from 'react';
import PropTypes from 'prop-types';

function PackageSelector({
    setPackage = () => {},
    packageObj = {},
    selectedPackage = {},
    currentPackage = {},
    features = [],
    ctaKey = '',
}) {
    const current = currentPackage ? currentPackage.name === packageObj.name : false;

    const selected = packageObj.name === selectedPackage.name;

    return (
        <div aria-label='package-selector' className={'package-selector border-color-gray-80 border-solid border-radius-10px cursor-pointer relative' + (selected ? ' border-color-blue-16 pointer-events-none' : '')}
            onClick={() => setPackage(packageObj)}
        >
            <div className="flex justify-content-space-between">
                <h1 className="font-size-24px font-serif font-blue-16 margin-0px">{packageObj.name}</h1>
                { current
                    ? <div aria-label='package-selector-current' className={'package-selector__current-package bg-blue-30 font-white border-radius-4px font-size-14px flex align-items-center justify-content-center'}>
                            Current
                    </div>
                    : <div aria-label='package-selector-circle' className={'package-selector-circle text-align-center relative border-radius-50' + (selected ? ' selected' : '')}>
                        { selected
                            ? <i className="fa fa-check font-size-20px font-white"></i>
                            : null
                        }
                    </div>
                }
            </div>
            { features.length > 0
                ? <div>
                    <ul className="package-selector__list-style font-size-14px font-w-4 none md-block text-align-left">
                        {features.map((feature, i) => (
                            <li key={i} className={feature.key === ctaKey || feature.key === 'all_starter_pro' ? 'font-purple-30 font-w-7' : ''} label={feature.label}>{feature.label}</li>
                        ))}
                    </ul>
                    <div className="font-gray-40 md-font-blue-16 font-serif font-size-20px text-align-center absolute md-bottom-0 md-right-0 md-left-0 margin-b-24px">
                        <span>{ packageObj.name !== 'Premium' ? `${packageObj.monthlyPrice}/month` : 'Talk to Support' }</span>
                    </div>
                </div>
                : <div>
                    <span className="font-size-20px font-serif font-gray-40 block">{ packageObj.name !== 'Premium' ? `${packageObj.monthlyPrice}/month` : 'Talk to Support' }</span>
                    <span className="font-size-14px font-sans-serif font-gray-40 block">Billed {packageObj.name !== 'Premium' ? `${packageObj.price}` : ''} annually</span>
                </div>
            }
        </div>
    );
}

PackageSelector.propTypes = {
    setPackage: PropTypes.func.isRequired,
    packageObj: PropTypes.object.isRequired,
    features: PropTypes.array,
    ctaKey: PropTypes.string,
    selectedPackage: PropTypes.object.isRequired,
    currentPackage: PropTypes.object,
};

export default PackageSelector;
